const isStudioComposite = (
  card: CanvasCard.Card,
): card is CanvasCard.StudioCompositeCard =>
  card.content.type === 'Studio Composite';

export default isStudioComposite;
